import * as React from "react";
import { forwardRef } from "react";
const SvgIcPanelClose24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 1, y: 1, width: 30, height: 30, stroke: "#1E293B", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M17.4295 15.7851L23.5814 9.46796L22.1518 8L16 14.3171L9.84819 8.00001L8.41865 9.46796L14.5704 15.7851L8 22.532L9.42955 24L16 17.253L22.5705 24L24 22.532L17.4295 15.7851Z", fill: "#94A3B8" }));
const ForwardRef = forwardRef(SvgIcPanelClose24);
export { ForwardRef as ReactComponent };
